(<template>
  <choose-gender />
</template>)

<script>
  import WizardChooseGender from '@/components/wizard_components/WizardChooseGender';

  export default {
    components: {
      'choose-gender': WizardChooseGender
    }
  };
</script>
